import React from 'react';
import { VictoryBar, VictoryChart, VictoryTheme, VictoryAxis, VictoryStack, VictoryLegend } from 'victory';

const SalesChart = (props) => {
   console.log(props.items);
   return (
      <>
         <VictoryChart theme={VictoryTheme.material} domainPadding={25} width={500} height={250}>
            <VictoryLegend
               x={70}
               y={10}
               orientation='horizontal'
               gutter={5}
               style={{ border: { stroke: '#1d2834' }, title: { fontSize: 8 } }}
               data={[
                  { name: 'Total Amount', symbol: { fill: '#1d2834' } },
                  { name: 'Average Amount', symbol: { fill: '#f64c72' } },
               ]}
            />
            <VictoryAxis
               style={{
                  tickLabels: { fontSize: 9, padding: 1 },
               }}
            />
            <VictoryAxis
               dependentAxis
               style={{
                  tickLabels: { fontSize: 9, padding: 2 },
               }}
               tickFormat={(x) => `FRW${x / 1000}k`}
            />
            {/* <VictoryStack colorScale={['#1d2834', '#f64c72', '#4a90e2']}> */}
            {/* <VictoryBar
                  height={250}
                  data={props.items}
                  x='saleStatusLabel'
                  y={['totalSalesAmount']}
                  labels={({ datum }) => {
                     if (datum) return `${datum.numberSales}`;
                  }}
               /> */}
            <VictoryBar height={250} data={props.items} x='saleStatusLabel' y={['averageSalesAmount']} />
            <VictoryBar width={250} data={props.items} x='saleStatusLabel' y={['numberSales']} />
            {/* </VictoryStack> */}
         </VictoryChart>
      </>
   );
};

export default SalesChart;
